let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kd2mS")).then(() => parcelRequire('hDyjh'));